import * as colors from "../../../styles/colors";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";

let lockingCounter = 0;
let originalBodyOverflow = null;

const styles = StyleSheet.create({
	root: {
		position: "fixed",
		height: "100%",
		width: "100%",
		top: 0,
		left: 0,
		opacity: 1,
		willChange: "opacity",
		transform: "translateZ(0)",
		backgroundColor: colors.textGrey,
	},
});

export default class Overlay extends PureComponent {
	static propTypes = {
		autoLockScrolling: PropTypes.bool,
		show: PropTypes.bool.isRequired,
		style: PropTypes.object,
		onClick: PropTypes.func.isRequired,
	};

	componentDidMount() {
		if (this.props.show && this.props.autoLockScrolling) {
			this._preventScrolling();
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.show !== this.props.show) {
			const locked = this.props.show && this.props.autoLockScrolling;
			if (locked !== this.locked) {
				if (locked) {
					this._preventScrolling();
				} else {
					this._allowScrolling();
				}
			}
		}
	}

	componentWillUnmount() {
		this._allowScrolling();
	}

	_allowScrolling = () => {
		if (this.locked === true) {
			lockingCounter = lockingCounter - 1;
			this.locked = false;
		}
		if (lockingCounter === 0 && originalBodyOverflow !== null) {
			const body = document.getElementsByTagName("body")[0];
			body.style.overflow = originalBodyOverflow || "";
			originalBodyOverflow = null;
		}
	};

	_preventScrolling = () => {
		if (this.locked === true) {
			return;
		}
		lockingCounter = lockingCounter + 1;
		this.locked = true;
		// only lock the first time the component is mounted.
		if (lockingCounter === 1) {
			const body = document.getElementsByTagName("body")[0];
			originalBodyOverflow = body.style.overflow;
			body.style.overflow = "hidden";
		}
	};

	render() {
		if (!this.props.show) {
			return null;
		}
		return (
			<div
				className={css(styles.root)}
				style={this.props.style}
				onClick={this.props.onClick}
			/>
		);
	}
}
